import { useEffect } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetMaintenanceStatuses } from 'core/Store/maintenanceStatuses/actions';
import { selectMaintenanceStatuses } from 'core/Store/maintenanceStatuses/selectors';
import { MaintenanceStatus } from 'core/types/maintenanceStatus';

let loading = false;

export default function useMaintenanceStatuses() {
  const showErrorNotification = useErrorNotifications();
  const [maintenances, dispatch] = useSubstate(selectMaintenanceStatuses);

  useEffect(() => {
    if (loading) {
      return;
    }

    loading = true;

    client()
      .get<MaintenanceStatus[]>(`maintenance_statuses`)
      .then(response => response.data)
      .then(statuses => dispatch(new SetMaintenanceStatuses(statuses)))
      .catch(showErrorNotification);
  }, [dispatch, showErrorNotification]);

  return maintenances;
}
